import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAppStateStore } from "@/stores/useAppState";
import { useAuthStore } from "@/stores/useAuth";

export const Route = createFileRoute("/_unauthenticated/auth/recover")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();

  // Open the modal only after the previous route has unmounted, otherwise
  // the modal flashes on top of the page the user was redirected from
  // (notably `_videoPlayer/$series/$episode`).
  useEffect(() => {
    const providers = useAuthStore.getState().currentUser?.providers;
    if (!providers || providers.length === 0)
      useAppStateStore.getState().openLoginModal({ origin: "recover" });
    navigate({ to: "/", replace: true });
  }, [navigate]);

  return null;
}
